<div class="d-flex justify-content-center mb-5">
    <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
    <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
    <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
</div>